

function TagList({ onTagClick, tags}) {

  const handleTagClick = (tag) => {
    onTagClick(tag);
  };


  return (
    
        <div style={styles.listColumn}>
          {/* TARJETA 2: Editar Etiquetas */}
          <div style={{ ...styles.card}}>
            <h2 style={styles.subtitle}>Etiquetar</h2>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
              Selecciona una etiqueta para etiquetar la conversacion.
            </p>
            
            {/* Lista interactiva para seleccionar */}
            <div style={styles.tagsGrid}>
              {tags.map((tag, index) => (
                <div 
                  key={`edit-list-${index}`} 
                  onClick={() => handleTagClick(tag)}
                  style={{ 
                    ...styles.tagBadge, 
                    backgroundColor: tag.color,
                    cursor: 'pointer',
                    opacity: 0.9,
                    // Si tienes un estado `editingTag`, puedes destacar el seleccionado:
                    // border: editingTag?.id === tag.id ? '2px solid #000' : 'none'
                  }}
                  title="Clic para etiquetar"
                >
                
                  {tag.name.toLowerCase()}⭐
                </div>
              ))}
            </div>


          </div>
        </div>
  );
}

const styles = {
  pageWrapper: { padding: '40px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' },
  mainTitle: { marginBottom: '30px', color: '#1a202c' },
  layout: { display: 'flex', gap: '30px', alignItems: 'flex-start' },
  formColumn: { flex: '1' },
  listColumn: { flex: '1.5' },
  card: { background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', border: '1px solid #edf2f7' },
  subtitle: { marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', color: '#4a5568', borderBottom: '1px solid #eee', paddingBottom: '10px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { fontSize: '14px', fontWeight: 'bold', color: '#4a5568' },
  input: { padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '16px' },
  palette: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  colorOption: { width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', transition: 'all 0.2s' },
  button: { padding: '14px', backgroundColor: '#25d366', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' },
  tagsGrid: { display: 'flex', flexWrap: 'wrap', gap: '10px' },
  tagBadge: { padding: '6px 14px', borderRadius: '20px', color: '#fff', fontSize: '13px', fontWeight: '600', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textTransform: 'capitalize' }
};


export default TagList;